export const environment = {
    production: true,
    apiUrl: 'https://dev-app-back.unbrid.com/panel-unbrid-back/api',
    shopUrl: 'https://dev-shop.unbrid.com',
    ntoUri: "https://dev-nto.unbrid.com/",
    appUnbrid:"https://dev-app.unbrid.com/"
  };
  